import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "closet-clothing-form" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "브랜드·모델·사이즈와 실측·핏을 기록하면 다음 구매 때 그대로 참고할 수 있어요", -1)
const _hoisted_5 = { class: "clothing-layout" }
const _hoisted_6 = { class: "clothing-form-section" }
const _hoisted_7 = { class: "form-section" }
const _hoisted_8 = { class: "form-title" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "form-group sm" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "카테고리", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-group sm" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "소분류", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "직접입력", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "form-group"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "소분류 입력", -1)
const _hoisted_19 = { class: "form-row" }
const _hoisted_20 = { class: "form-group sm" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "브랜드", -1)
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "제품명", -1)
const _hoisted_24 = { class: "form-group sm" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, "표기 사이즈", -1)
const _hoisted_26 = { class: "form-group sm" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "구매일", -1)
const _hoisted_28 = {
  key: 0,
  class: "measure-section"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "measure-title" }, "실측 치수", -1)
const _hoisted_30 = { class: "form-row" }
const _hoisted_31 = ["data-tooltip"]
const _hoisted_32 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_33 = { class: "form-row" }
const _hoisted_34 = { class: "form-group sm" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "만족도", -1)
const _hoisted_36 = { class: "star-rating" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "form-group fit-group" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "핏 평가", -1)
const _hoisted_40 = { class: "fit-seg" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "form-row" }
const _hoisted_43 = { class: "form-group wide" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", null, "메모", -1)
const _hoisted_45 = { class: "form-actions" }
const _hoisted_46 = { class: "clothing-svg-section" }
const _hoisted_47 = { class: "svg-card" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "svg-title" }, "의류 치수 다이어그램", -1)
const _hoisted_49 = { class: "svg-container" }
const _hoisted_50 = {
  key: 0,
  viewBox: "0 0 300 360",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "topGrad",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#dce8f5"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "#eef4fc"
    })
  ])
], -1)
const _hoisted_52 = ["d"]
const _hoisted_53 = { key: 0 }
const _hoisted_54 = ["x1", "y1", "x2", "y2"]
const _hoisted_55 = ["x1", "y1", "x2", "y2"]
const _hoisted_56 = ["x1", "y1", "x2", "y2"]
const _hoisted_57 = ["x", "y"]
const _hoisted_58 = ["x", "y"]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = ["x1", "y1", "x2", "y2"]
const _hoisted_61 = ["x1", "y1", "x2", "y2"]
const _hoisted_62 = ["x1", "y1", "x2", "y2"]
const _hoisted_63 = ["y"]
const _hoisted_64 = ["y"]
const _hoisted_65 = { key: 2 }
const _hoisted_66 = ["x1", "y1", "x2", "y2"]
const _hoisted_67 = ["x1", "y1", "x2", "y2"]
const _hoisted_68 = ["x1", "y1", "x2", "y2"]
const _hoisted_69 = ["x", "y"]
const _hoisted_70 = ["x", "y"]
const _hoisted_71 = { key: 3 }
const _hoisted_72 = ["x1", "y1", "x2", "y2"]
const _hoisted_73 = ["x", "y"]
const _hoisted_74 = ["x", "y"]
const _hoisted_75 = { key: 4 }
const _hoisted_76 = ["x1", "y1", "x2", "y2"]
const _hoisted_77 = ["x1", "y1", "x2", "y2"]
const _hoisted_78 = ["x1", "y1", "x2", "y2"]
const _hoisted_79 = ["y"]
const _hoisted_80 = ["y"]
const _hoisted_81 = { key: 5 }
const _hoisted_82 = ["x1", "y1", "x2", "y2"]
const _hoisted_83 = ["cx", "cy"]
const _hoisted_84 = ["cx", "cy"]
const _hoisted_85 = ["x", "y"]
const _hoisted_86 = ["x", "y"]
const _hoisted_87 = {
  key: 1,
  viewBox: "0 0 300 400",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "bottomGrad",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#dce8f5"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "#eef4fc"
    })
  ])
], -1)
const _hoisted_89 = ["d"]
const _hoisted_90 = { key: 0 }
const _hoisted_91 = ["x1", "y1", "x2", "y2"]
const _hoisted_92 = ["x1", "y1", "x2", "y2"]
const _hoisted_93 = ["x1", "y1", "x2", "y2"]
const _hoisted_94 = ["x", "y"]
const _hoisted_95 = ["x", "y"]
const _hoisted_96 = { key: 1 }
const _hoisted_97 = ["x1", "y1", "x2", "y2"]
const _hoisted_98 = ["x1", "y1", "x2", "y2"]
const _hoisted_99 = ["x1", "y1", "x2", "y2"]
const _hoisted_100 = ["y"]
const _hoisted_101 = ["y"]
const _hoisted_102 = { key: 2 }
const _hoisted_103 = ["x1", "y1", "x2", "y2"]
const _hoisted_104 = ["x1", "y1", "x2", "y2"]
const _hoisted_105 = ["x1", "y1", "x2", "y2"]
const _hoisted_106 = ["x", "y"]
const _hoisted_107 = ["x", "y"]
const _hoisted_108 = { key: 3 }
const _hoisted_109 = ["x1", "y1", "x2", "y2"]
const _hoisted_110 = ["x1", "y1", "x2", "y2"]
const _hoisted_111 = ["x1", "y1", "x2", "y2"]
const _hoisted_112 = ["x", "y"]
const _hoisted_113 = ["x", "y"]
const _hoisted_114 = { key: 4 }
const _hoisted_115 = ["x1", "y1", "x2", "y2"]
const _hoisted_116 = ["x1", "y1", "x2", "y2"]
const _hoisted_117 = ["x1", "y1", "x2", "y2"]
const _hoisted_118 = ["x", "y"]
const _hoisted_119 = ["x", "y"]
const _hoisted_120 = { key: 5 }
const _hoisted_121 = ["x1", "y1", "x2", "y2"]
const _hoisted_122 = ["x1", "y1", "x2", "y2"]
const _hoisted_123 = ["x1", "y1", "x2", "y2"]
const _hoisted_124 = ["x", "y"]
const _hoisted_125 = ["x", "y"]
const _hoisted_126 = {
  key: 2,
  viewBox: "0 0 300 400",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_127 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "opGrad",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#f0dce8"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "#fceef4"
    })
  ])
], -1)
const _hoisted_128 = ["d"]
const _hoisted_129 = { key: 0 }
const _hoisted_130 = ["x1", "y1", "x2", "y2"]
const _hoisted_131 = ["x1", "y1", "x2", "y2"]
const _hoisted_132 = ["x1", "y1", "x2", "y2"]
const _hoisted_133 = ["x", "y"]
const _hoisted_134 = ["x", "y"]
const _hoisted_135 = { key: 1 }
const _hoisted_136 = ["x1", "y1", "x2", "y2"]
const _hoisted_137 = ["x1", "y1", "x2", "y2"]
const _hoisted_138 = ["x1", "y1", "x2", "y2"]
const _hoisted_139 = ["y"]
const _hoisted_140 = ["y"]
const _hoisted_141 = { key: 2 }
const _hoisted_142 = ["x1", "y1", "x2", "y2"]
const _hoisted_143 = ["x", "y"]
const _hoisted_144 = ["x", "y"]
const _hoisted_145 = { key: 3 }
const _hoisted_146 = ["x1", "y1", "x2", "y2"]
const _hoisted_147 = ["x", "y"]
const _hoisted_148 = ["x", "y"]
const _hoisted_149 = { key: 4 }
const _hoisted_150 = ["x1", "y1", "x2", "y2"]
const _hoisted_151 = ["x", "y"]
const _hoisted_152 = ["x", "y"]
const _hoisted_153 = { key: 5 }
const _hoisted_154 = ["x1", "y1", "x2", "y2"]
const _hoisted_155 = ["x", "y"]
const _hoisted_156 = ["x", "y"]
const _hoisted_157 = {
  key: 3,
  viewBox: "0 0 300 200",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_158 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "shoeGrad",
    x1: "0",
    y1: "0",
    x2: "1",
    y2: "0"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      "stop-color": "#e8e0d4"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "#f5f0e8"
    })
  ])
], -1)
const _hoisted_159 = ["d"]
const _hoisted_160 = { key: 0 }
const _hoisted_161 = ["x1", "y1", "x2", "y2"]
const _hoisted_162 = ["x1", "y1", "x2", "y2"]
const _hoisted_163 = ["x1", "y1", "x2", "y2"]
const _hoisted_164 = ["x", "y"]
const _hoisted_165 = ["x", "y"]
const _hoisted_166 = { key: 1 }
const _hoisted_167 = ["x1", "y1", "x2", "y2"]
const _hoisted_168 = ["x1", "y1", "x2", "y2"]
const _hoisted_169 = ["x1", "y1", "x2", "y2"]
const _hoisted_170 = ["x", "y"]
const _hoisted_171 = ["x", "y"]
const _hoisted_172 = {
  key: 4,
  class: "svg-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.isEditMode ? "의류 수정" : "의류 등록"), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(_ctx.isEditMode ? "의류 수정" : "의류 등록"), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.clothingForm.category) = $event)),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCategoryChange && _ctx.onCategoryChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryOptions, (opt) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: opt.value,
                    value: opt.value
                  }, _toDisplayString(opt.label), 9, _hoisted_12))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.clothingForm.category]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.clothingForm.subCategory) = $event))
              }, [
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSubCategories, (sub) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: sub,
                    value: sub
                  }, _toDisplayString(sub), 9, _hoisted_16))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.clothingForm.subCategory]
              ])
            ]),
            (_ctx.clothingForm.subCategory === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customSubCategory) = $event)),
                    placeholder: "소분류 직접 입력",
                    maxlength: "50"
                  }, null, 512), [
                    [_vModelText, _ctx.customSubCategory]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.clothingForm.brandName) = $event)),
                placeholder: "브랜드명",
                maxlength: "100"
              }, null, 512), [
                [_vModelText, _ctx.clothingForm.brandName]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.clothingForm.productName) = $event)),
                placeholder: "제품명",
                maxlength: "200"
              }, null, 512), [
                [_vModelText, _ctx.clothingForm.productName]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.clothingForm.labeledSize) = $event)),
                placeholder: "M, L, 95 등",
                maxlength: "20"
              }, null, 512), [
                [_vModelText, _ctx.clothingForm.labeledSize]
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.clothingForm.purchaseDate) = $event))
              }, null, 512), [
                [_vModelText, _ctx.clothingForm.purchaseDate]
              ])
            ])
          ]),
          (_ctx.currentMeasureFields.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentMeasureFields, (field) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-group sm",
                      key: field.key
                    }, [
                      _createElementVNode("label", null, [
                        _createTextVNode(_toDisplayString(field.label) + " (" + _toDisplayString(field.unit) + ") ", 1),
                        (_ctx.CLOTHING_MEASURE_HELP[field.key])
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "help-icon",
                              "data-tooltip": _ctx.CLOTHING_MEASURE_HELP[field.key]
                            }, "?", 8, _hoisted_31))
                          : _createCommentVNode("", true)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.clothingForm.measurements[field.key]) = $event),
                        placeholder: field.label,
                        step: "0.1"
                      }, null, 8, _hoisted_32), [
                        [
                          _vModelText,
                          _ctx.clothingForm.measurements[field.key],
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (s) => {
                  return _createElementVNode("span", {
                    key: s,
                    class: _normalizeClass(["star", { active: _ctx.clothingForm.satisfaction != null && s <= _ctx.clothingForm.satisfaction }]),
                    onClick: ($event: any) => (_ctx.clothingForm.satisfaction = s)
                  }, "★", 10, _hoisted_37)
                }), 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fitFeedbackOptions, (opt) => {
                  return (_openBlock(), _createElementBlock("button", {
                    type: "button",
                    key: opt.value,
                    class: _normalizeClass(["fit-seg-btn", [_ctx.fitClass(opt.value), { on: _ctx.clothingForm.fitFeedback === opt.value }]]),
                    onClick: ($event: any) => (_ctx.clothingForm.fitFeedback = _ctx.clothingForm.fitFeedback === opt.value ? '' : opt.value)
                  }, _toDisplayString(opt.label), 11, _hoisted_41))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.clothingForm.memo) = $event)),
                placeholder: "메모",
                maxlength: "500"
              }, null, 512), [
                [_vModelText, _ctx.clothingForm.memo]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("button", {
              class: "btn-secondary",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
            }, "취소"),
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submitClothing && _ctx.submitClothing(...args)))
            }, _toDisplayString(_ctx.isEditMode ? "수정" : "등록"), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, [
            (_ctx.svgCategory === 'TOP')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("path", {
                    d: _ctx.topSvgPath,
                    fill: "url(#topGrad)",
                    stroke: "#4a90d9",
                    "stroke-width": "2",
                    "stroke-linejoin": "round"
                  }, null, 8, _hoisted_52),
                  (_ctx.m.total_length)
                    ? (_openBlock(), _createElementBlock("g", _hoisted_53, [
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.leftEdge - 20,
                          y1: _ctx.topCoords.topY,
                          x2: _ctx.topCoords.leftEdge - 20,
                          y2: _ctx.topCoords.bottomY,
                          stroke: "#888",
                          "stroke-width": "0.8",
                          "stroke-dasharray": "4,2"
                        }, null, 8, _hoisted_54),
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.leftEdge - 24,
                          y1: _ctx.topCoords.topY,
                          x2: _ctx.topCoords.leftEdge - 16,
                          y2: _ctx.topCoords.topY,
                          stroke: "#888",
                          "stroke-width": "1"
                        }, null, 8, _hoisted_55),
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.leftEdge - 24,
                          y1: _ctx.topCoords.bottomY,
                          x2: _ctx.topCoords.leftEdge - 16,
                          y2: _ctx.topCoords.bottomY,
                          stroke: "#888",
                          "stroke-width": "1"
                        }, null, 8, _hoisted_56),
                        _createElementVNode("rect", {
                          x: _ctx.topCoords.leftEdge - 50,
                          y: (_ctx.topCoords.topY + _ctx.topCoords.bottomY) / 2 - 8,
                          width: "56",
                          height: "16",
                          rx: "3",
                          fill: "#fff",
                          stroke: "#ddd",
                          "stroke-width": "0.5"
                        }, null, 8, _hoisted_57),
                        _createElementVNode("text", {
                          x: _ctx.topCoords.leftEdge - 22,
                          y: (_ctx.topCoords.topY + _ctx.topCoords.bottomY) / 2 + 4,
                          "text-anchor": "middle",
                          class: "svg-measure-label"
                        }, "총장 " + _toDisplayString(_ctx.m.total_length) + "cm", 9, _hoisted_58)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.m.shoulder_width)
                    ? (_openBlock(), _createElementBlock("g", _hoisted_59, [
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.shoulderL,
                          y1: _ctx.topCoords.topY - 16,
                          x2: _ctx.topCoords.shoulderR,
                          y2: _ctx.topCoords.topY - 16,
                          stroke: "#e74c3c",
                          "stroke-width": "0.8",
                          "stroke-dasharray": "4,2"
                        }, null, 8, _hoisted_60),
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.shoulderL,
                          y1: _ctx.topCoords.topY - 20,
                          x2: _ctx.topCoords.shoulderL,
                          y2: _ctx.topCoords.topY - 12,
                          stroke: "#e74c3c",
                          "stroke-width": "1"
                        }, null, 8, _hoisted_61),
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.shoulderR,
                          y1: _ctx.topCoords.topY - 20,
                          x2: _ctx.topCoords.shoulderR,
                          y2: _ctx.topCoords.topY - 12,
                          stroke: "#e74c3c",
                          "stroke-width": "1"
                        }, null, 8, _hoisted_62),
                        _createElementVNode("rect", {
                          x: 150 - 34,
                          y: _ctx.topCoords.topY - 34,
                          width: "68",
                          height: "16",
                          rx: "3",
                          fill: "#fff",
                          stroke: "#f0c0c0",
                          "stroke-width": "0.5"
                        }, null, 8, _hoisted_63),
                        _createElementVNode("text", {
                          x: "150",
                          y: _ctx.topCoords.topY - 23,
                          "text-anchor": "middle",
                          class: "svg-measure-label red"
                        }, "어깨 " + _toDisplayString(_ctx.m.shoulder_width) + "cm", 9, _hoisted_64)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.m.chest_width)
                    ? (_openBlock(), _createElementBlock("g", _hoisted_65, [
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.chestL,
                          y1: _ctx.topCoords.chestY,
                          x2: _ctx.topCoords.chestR,
                          y2: _ctx.topCoords.chestY,
                          stroke: "#e74c3c",
                          "stroke-width": "0.8",
                          "stroke-dasharray": "4,2"
                        }, null, 8, _hoisted_66),
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.chestL,
                          y1: _ctx.topCoords.chestY - 4,
                          x2: _ctx.topCoords.chestL,
                          y2: _ctx.topCoords.chestY + 4,
                          stroke: "#e74c3c",
                          "stroke-width": "1"
                        }, null, 8, _hoisted_67),
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.chestR,
                          y1: _ctx.topCoords.chestY - 4,
                          x2: _ctx.topCoords.chestR,
                          y2: _ctx.topCoords.chestY + 4,
                          stroke: "#e74c3c",
                          "stroke-width": "1"
                        }, null, 8, _hoisted_68),
                        _createElementVNode("rect", {
                          x: (_ctx.topCoords.chestL + _ctx.topCoords.chestR) / 2 - 34,
                          y: _ctx.topCoords.chestY + 8,
                          width: "68",
                          height: "16",
                          rx: "3",
                          fill: "#fff",
                          stroke: "#f0c0c0",
                          "stroke-width": "0.5"
                        }, null, 8, _hoisted_69),
                        _createElementVNode("text", {
                          x: (_ctx.topCoords.chestL + _ctx.topCoords.chestR) / 2,
                          y: _ctx.topCoords.chestY + 20,
                          "text-anchor": "middle",
                          class: "svg-measure-label red"
                        }, "가슴 " + _toDisplayString(_ctx.m.chest_width) + "cm", 9, _hoisted_70)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.m.sleeve_length)
                    ? (_openBlock(), _createElementBlock("g", _hoisted_71, [
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.shoulderR,
                          y1: _ctx.topCoords.topY,
                          x2: _ctx.topCoords.sleeveEndX,
                          y2: _ctx.topCoords.sleeveEndY,
                          stroke: "#3498db",
                          "stroke-width": "0.8",
                          "stroke-dasharray": "4,2"
                        }, null, 8, _hoisted_72),
                        _createElementVNode("rect", {
                          x: (_ctx.topCoords.shoulderR + _ctx.topCoords.sleeveEndX) / 2 - 34,
                          y: (_ctx.topCoords.topY + _ctx.topCoords.sleeveEndY) / 2 - 18,
                          width: "68",
                          height: "16",
                          rx: "3",
                          fill: "#fff",
                          stroke: "#c0d8f0",
                          "stroke-width": "0.5"
                        }, null, 8, _hoisted_73),
                        _createElementVNode("text", {
                          x: (_ctx.topCoords.shoulderR + _ctx.topCoords.sleeveEndX) / 2,
                          y: (_ctx.topCoords.topY + _ctx.topCoords.sleeveEndY) / 2 - 6,
                          "text-anchor": "middle",
                          class: "svg-measure-label blue"
                        }, "소매 " + _toDisplayString(_ctx.m.sleeve_length) + "cm", 9, _hoisted_74)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.m.hem_width)
                    ? (_openBlock(), _createElementBlock("g", _hoisted_75, [
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.hemL,
                          y1: _ctx.topCoords.bottomY + 12,
                          x2: _ctx.topCoords.hemR,
                          y2: _ctx.topCoords.bottomY + 12,
                          stroke: "#27ae60",
                          "stroke-width": "0.8",
                          "stroke-dasharray": "4,2"
                        }, null, 8, _hoisted_76),
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.hemL,
                          y1: _ctx.topCoords.bottomY + 8,
                          x2: _ctx.topCoords.hemL,
                          y2: _ctx.topCoords.bottomY + 16,
                          stroke: "#27ae60",
                          "stroke-width": "1"
                        }, null, 8, _hoisted_77),
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.hemR,
                          y1: _ctx.topCoords.bottomY + 8,
                          x2: _ctx.topCoords.hemR,
                          y2: _ctx.topCoords.bottomY + 16,
                          stroke: "#27ae60",
                          "stroke-width": "1"
                        }, null, 8, _hoisted_78),
                        _createElementVNode("rect", {
                          x: 150 - 30,
                          y: _ctx.topCoords.bottomY + 18,
                          width: "60",
                          height: "16",
                          rx: "3",
                          fill: "#fff",
                          stroke: "#b0d8b0",
                          "stroke-width": "0.5"
                        }, null, 8, _hoisted_79),
                        _createElementVNode("text", {
                          x: "150",
                          y: _ctx.topCoords.bottomY + 30,
                          "text-anchor": "middle",
                          class: "svg-measure-label green"
                        }, "밑단 " + _toDisplayString(_ctx.m.hem_width) + "cm", 9, _hoisted_80)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.m.armhole)
                    ? (_openBlock(), _createElementBlock("g", _hoisted_81, [
                        _createElementVNode("line", {
                          x1: _ctx.topCoords.shoulderR,
                          y1: _ctx.topCoords.topY,
                          x2: _ctx.topCoords.rArmX,
                          y2: _ctx.topCoords.rArmY,
                          stroke: "#8e44ad",
                          "stroke-width": "0.8",
                          "stroke-dasharray": "4,2"
                        }, null, 8, _hoisted_82),
                        _createElementVNode("circle", {
                          cx: _ctx.topCoords.shoulderR,
                          cy: _ctx.topCoords.topY,
                          r: "2",
                          fill: "#8e44ad"
                        }, null, 8, _hoisted_83),
                        _createElementVNode("circle", {
                          cx: _ctx.topCoords.rArmX,
                          cy: _ctx.topCoords.rArmY,
                          r: "2",
                          fill: "#8e44ad"
                        }, null, 8, _hoisted_84),
                        _createElementVNode("rect", {
                          x: _ctx.topCoords.shoulderR - 68,
                          y: (_ctx.topCoords.topY + _ctx.topCoords.rArmY) / 2 - 8,
                          width: "62",
                          height: "16",
                          rx: "3",
                          fill: "#fff",
                          stroke: "#d8c0f0",
                          "stroke-width": "0.5"
                        }, null, 8, _hoisted_85),
                        _createElementVNode("text", {
                          x: _ctx.topCoords.shoulderR - 37,
                          y: (_ctx.topCoords.topY + _ctx.topCoords.rArmY) / 2 + 4,
                          "text-anchor": "middle",
                          class: "svg-measure-label purple"
                        }, "암홀 " + _toDisplayString(_ctx.m.armhole) + "cm", 9, _hoisted_86)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.svgCategory === 'BOTTOM')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_87, [
                    _hoisted_88,
                    _createElementVNode("path", {
                      d: _ctx.bottomSvgPath,
                      fill: "url(#bottomGrad)",
                      stroke: "#4a90d9",
                      "stroke-width": "2",
                      "stroke-linejoin": "round"
                    }, null, 8, _hoisted_89),
                    (_ctx.m.total_length)
                      ? (_openBlock(), _createElementBlock("g", _hoisted_90, [
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.leftEdge - 20,
                            y1: _ctx.btmCoords.topY,
                            x2: _ctx.btmCoords.leftEdge - 20,
                            y2: _ctx.btmCoords.bottomY,
                            stroke: "#888",
                            "stroke-width": "0.8",
                            "stroke-dasharray": "4,2"
                          }, null, 8, _hoisted_91),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.leftEdge - 24,
                            y1: _ctx.btmCoords.topY,
                            x2: _ctx.btmCoords.leftEdge - 16,
                            y2: _ctx.btmCoords.topY,
                            stroke: "#888",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_92),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.leftEdge - 24,
                            y1: _ctx.btmCoords.bottomY,
                            x2: _ctx.btmCoords.leftEdge - 16,
                            y2: _ctx.btmCoords.bottomY,
                            stroke: "#888",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_93),
                          _createElementVNode("rect", {
                            x: _ctx.btmCoords.leftEdge - 50,
                            y: (_ctx.btmCoords.topY + _ctx.btmCoords.bottomY) / 2 - 8,
                            width: "56",
                            height: "16",
                            rx: "3",
                            fill: "#fff",
                            stroke: "#ddd",
                            "stroke-width": "0.5"
                          }, null, 8, _hoisted_94),
                          _createElementVNode("text", {
                            x: _ctx.btmCoords.leftEdge - 22,
                            y: (_ctx.btmCoords.topY + _ctx.btmCoords.bottomY) / 2 + 4,
                            "text-anchor": "middle",
                            class: "svg-measure-label"
                          }, "총장 " + _toDisplayString(_ctx.m.total_length) + "cm", 9, _hoisted_95)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.m.waist_width)
                      ? (_openBlock(), _createElementBlock("g", _hoisted_96, [
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.waistL,
                            y1: _ctx.btmCoords.topY - 14,
                            x2: _ctx.btmCoords.waistR,
                            y2: _ctx.btmCoords.topY - 14,
                            stroke: "#e74c3c",
                            "stroke-width": "0.8",
                            "stroke-dasharray": "4,2"
                          }, null, 8, _hoisted_97),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.waistL,
                            y1: _ctx.btmCoords.topY - 18,
                            x2: _ctx.btmCoords.waistL,
                            y2: _ctx.btmCoords.topY - 10,
                            stroke: "#e74c3c",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_98),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.waistR,
                            y1: _ctx.btmCoords.topY - 18,
                            x2: _ctx.btmCoords.waistR,
                            y2: _ctx.btmCoords.topY - 10,
                            stroke: "#e74c3c",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_99),
                          _createElementVNode("rect", {
                            x: 150 - 34,
                            y: _ctx.btmCoords.topY - 32,
                            width: "68",
                            height: "16",
                            rx: "3",
                            fill: "#fff",
                            stroke: "#f0c0c0",
                            "stroke-width": "0.5"
                          }, null, 8, _hoisted_100),
                          _createElementVNode("text", {
                            x: "150",
                            y: _ctx.btmCoords.topY - 21,
                            "text-anchor": "middle",
                            class: "svg-measure-label red"
                          }, "허리 " + _toDisplayString(_ctx.m.waist_width) + "cm", 9, _hoisted_101)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.m.hip_width)
                      ? (_openBlock(), _createElementBlock("g", _hoisted_102, [
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.hipL,
                            y1: _ctx.btmCoords.hipY,
                            x2: _ctx.btmCoords.hipR,
                            y2: _ctx.btmCoords.hipY,
                            stroke: "#e74c3c",
                            "stroke-width": "0.8",
                            "stroke-dasharray": "4,2"
                          }, null, 8, _hoisted_103),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.hipL,
                            y1: _ctx.btmCoords.hipY - 4,
                            x2: _ctx.btmCoords.hipL,
                            y2: _ctx.btmCoords.hipY + 4,
                            stroke: "#e74c3c",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_104),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.hipR,
                            y1: _ctx.btmCoords.hipY - 4,
                            x2: _ctx.btmCoords.hipR,
                            y2: _ctx.btmCoords.hipY + 4,
                            stroke: "#e74c3c",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_105),
                          _createElementVNode("rect", {
                            x: _ctx.btmCoords.hipR + 6,
                            y: _ctx.btmCoords.hipY - 8,
                            width: "68",
                            height: "16",
                            rx: "3",
                            fill: "#fff",
                            stroke: "#f0c0c0",
                            "stroke-width": "0.5"
                          }, null, 8, _hoisted_106),
                          _createElementVNode("text", {
                            x: _ctx.btmCoords.hipR + 40,
                            y: _ctx.btmCoords.hipY + 4,
                            "text-anchor": "middle",
                            class: "svg-measure-label red"
                          }, "엉덩이 " + _toDisplayString(_ctx.m.hip_width) + "cm", 9, _hoisted_107)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.m.thigh_width)
                      ? (_openBlock(), _createElementBlock("g", _hoisted_108, [
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.thighL,
                            y1: _ctx.btmCoords.thighY,
                            x2: _ctx.btmCoords.thighMid,
                            y2: _ctx.btmCoords.thighY,
                            stroke: "#3498db",
                            "stroke-width": "0.8",
                            "stroke-dasharray": "4,2"
                          }, null, 8, _hoisted_109),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.thighL,
                            y1: _ctx.btmCoords.thighY - 4,
                            x2: _ctx.btmCoords.thighL,
                            y2: _ctx.btmCoords.thighY + 4,
                            stroke: "#3498db",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_110),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.thighMid,
                            y1: _ctx.btmCoords.thighY - 4,
                            x2: _ctx.btmCoords.thighMid,
                            y2: _ctx.btmCoords.thighY + 4,
                            stroke: "#3498db",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_111),
                          _createElementVNode("rect", {
                            x: _ctx.btmCoords.thighL - 4,
                            y: _ctx.btmCoords.thighY + 6,
                            width: "72",
                            height: "16",
                            rx: "3",
                            fill: "#fff",
                            stroke: "#c0d8f0",
                            "stroke-width": "0.5"
                          }, null, 8, _hoisted_112),
                          _createElementVNode("text", {
                            x: _ctx.btmCoords.thighL + 32,
                            y: _ctx.btmCoords.thighY + 18,
                            "text-anchor": "middle",
                            class: "svg-measure-label blue"
                          }, "허벅지 " + _toDisplayString(_ctx.m.thigh_width) + "cm", 9, _hoisted_113)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.m.rise)
                      ? (_openBlock(), _createElementBlock("g", _hoisted_114, [
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.waistR + 16,
                            y1: _ctx.btmCoords.topY,
                            x2: _ctx.btmCoords.waistR + 16,
                            y2: _ctx.btmCoords.crotchY,
                            stroke: "#27ae60",
                            "stroke-width": "0.8",
                            "stroke-dasharray": "4,2"
                          }, null, 8, _hoisted_115),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.waistR + 12,
                            y1: _ctx.btmCoords.topY,
                            x2: _ctx.btmCoords.waistR + 20,
                            y2: _ctx.btmCoords.topY,
                            stroke: "#27ae60",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_116),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.waistR + 12,
                            y1: _ctx.btmCoords.crotchY,
                            x2: _ctx.btmCoords.waistR + 20,
                            y2: _ctx.btmCoords.crotchY,
                            stroke: "#27ae60",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_117),
                          _createElementVNode("rect", {
                            x: _ctx.btmCoords.waistR + 22,
                            y: (_ctx.btmCoords.topY + _ctx.btmCoords.crotchY) / 2 - 8,
                            width: "56",
                            height: "16",
                            rx: "3",
                            fill: "#fff",
                            stroke: "#b0d8b0",
                            "stroke-width": "0.5"
                          }, null, 8, _hoisted_118),
                          _createElementVNode("text", {
                            x: _ctx.btmCoords.waistR + 50,
                            y: (_ctx.btmCoords.topY + _ctx.btmCoords.crotchY) / 2 + 4,
                            "text-anchor": "middle",
                            class: "svg-measure-label green"
                          }, "밑위 " + _toDisplayString(_ctx.m.rise) + "cm", 9, _hoisted_119)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.m.hem_width)
                      ? (_openBlock(), _createElementBlock("g", _hoisted_120, [
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.hemL,
                            y1: _ctx.btmCoords.bottomY + 12,
                            x2: _ctx.btmCoords.hemMid,
                            y2: _ctx.btmCoords.bottomY + 12,
                            stroke: "#27ae60",
                            "stroke-width": "0.8",
                            "stroke-dasharray": "4,2"
                          }, null, 8, _hoisted_121),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.hemL,
                            y1: _ctx.btmCoords.bottomY + 8,
                            x2: _ctx.btmCoords.hemL,
                            y2: _ctx.btmCoords.bottomY + 16,
                            stroke: "#27ae60",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_122),
                          _createElementVNode("line", {
                            x1: _ctx.btmCoords.hemMid,
                            y1: _ctx.btmCoords.bottomY + 8,
                            x2: _ctx.btmCoords.hemMid,
                            y2: _ctx.btmCoords.bottomY + 16,
                            stroke: "#27ae60",
                            "stroke-width": "1"
                          }, null, 8, _hoisted_123),
                          _createElementVNode("rect", {
                            x: _ctx.btmCoords.hemL - 4,
                            y: _ctx.btmCoords.bottomY + 20,
                            width: "60",
                            height: "16",
                            rx: "3",
                            fill: "#fff",
                            stroke: "#b0d8b0",
                            "stroke-width": "0.5"
                          }, null, 8, _hoisted_124),
                          _createElementVNode("text", {
                            x: _ctx.btmCoords.hemL + 26,
                            y: _ctx.btmCoords.bottomY + 32,
                            "text-anchor": "middle",
                            class: "svg-measure-label green"
                          }, "밑단 " + _toDisplayString(_ctx.m.hem_width) + "cm", 9, _hoisted_125)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.svgCategory === 'ONEPIECE')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_126, [
                      _hoisted_127,
                      _createElementVNode("path", {
                        d: _ctx.onepieceSvgPath,
                        fill: "url(#opGrad)",
                        stroke: "#c0608a",
                        "stroke-width": "2",
                        "stroke-linejoin": "round"
                      }, null, 8, _hoisted_128),
                      (_ctx.m.total_length)
                        ? (_openBlock(), _createElementBlock("g", _hoisted_129, [
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.leftEdge - 20,
                              y1: _ctx.opCoords.topY,
                              x2: _ctx.opCoords.leftEdge - 20,
                              y2: _ctx.opCoords.bottomY,
                              stroke: "#888",
                              "stroke-width": "0.8",
                              "stroke-dasharray": "4,2"
                            }, null, 8, _hoisted_130),
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.leftEdge - 24,
                              y1: _ctx.opCoords.topY,
                              x2: _ctx.opCoords.leftEdge - 16,
                              y2: _ctx.opCoords.topY,
                              stroke: "#888",
                              "stroke-width": "1"
                            }, null, 8, _hoisted_131),
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.leftEdge - 24,
                              y1: _ctx.opCoords.bottomY,
                              x2: _ctx.opCoords.leftEdge - 16,
                              y2: _ctx.opCoords.bottomY,
                              stroke: "#888",
                              "stroke-width": "1"
                            }, null, 8, _hoisted_132),
                            _createElementVNode("rect", {
                              x: _ctx.opCoords.leftEdge - 50,
                              y: (_ctx.opCoords.topY + _ctx.opCoords.bottomY) / 2 - 8,
                              width: "56",
                              height: "16",
                              rx: "3",
                              fill: "#fff",
                              stroke: "#ddd",
                              "stroke-width": "0.5"
                            }, null, 8, _hoisted_133),
                            _createElementVNode("text", {
                              x: _ctx.opCoords.leftEdge - 22,
                              y: (_ctx.opCoords.topY + _ctx.opCoords.bottomY) / 2 + 4,
                              "text-anchor": "middle",
                              class: "svg-measure-label"
                            }, "총장 " + _toDisplayString(_ctx.m.total_length) + "cm", 9, _hoisted_134)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.m.shoulder_width)
                        ? (_openBlock(), _createElementBlock("g", _hoisted_135, [
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.shoulderL,
                              y1: _ctx.opCoords.topY - 14,
                              x2: _ctx.opCoords.shoulderR,
                              y2: _ctx.opCoords.topY - 14,
                              stroke: "#e74c3c",
                              "stroke-width": "0.8",
                              "stroke-dasharray": "4,2"
                            }, null, 8, _hoisted_136),
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.shoulderL,
                              y1: _ctx.opCoords.topY - 18,
                              x2: _ctx.opCoords.shoulderL,
                              y2: _ctx.opCoords.topY - 10,
                              stroke: "#e74c3c",
                              "stroke-width": "1"
                            }, null, 8, _hoisted_137),
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.shoulderR,
                              y1: _ctx.opCoords.topY - 18,
                              x2: _ctx.opCoords.shoulderR,
                              y2: _ctx.opCoords.topY - 10,
                              stroke: "#e74c3c",
                              "stroke-width": "1"
                            }, null, 8, _hoisted_138),
                            _createElementVNode("rect", {
                              x: 150 - 34,
                              y: _ctx.opCoords.topY - 32,
                              width: "68",
                              height: "16",
                              rx: "3",
                              fill: "#fff",
                              stroke: "#f0c0c0",
                              "stroke-width": "0.5"
                            }, null, 8, _hoisted_139),
                            _createElementVNode("text", {
                              x: "150",
                              y: _ctx.opCoords.topY - 21,
                              "text-anchor": "middle",
                              class: "svg-measure-label red"
                            }, "어깨 " + _toDisplayString(_ctx.m.shoulder_width) + "cm", 9, _hoisted_140)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.m.chest_width)
                        ? (_openBlock(), _createElementBlock("g", _hoisted_141, [
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.chestL,
                              y1: _ctx.opCoords.chestY,
                              x2: _ctx.opCoords.chestR,
                              y2: _ctx.opCoords.chestY,
                              stroke: "#e74c3c",
                              "stroke-width": "0.8",
                              "stroke-dasharray": "4,2"
                            }, null, 8, _hoisted_142),
                            _createElementVNode("rect", {
                              x: _ctx.opCoords.chestR + 6,
                              y: _ctx.opCoords.chestY - 8,
                              width: "68",
                              height: "16",
                              rx: "3",
                              fill: "#fff",
                              stroke: "#f0c0c0",
                              "stroke-width": "0.5"
                            }, null, 8, _hoisted_143),
                            _createElementVNode("text", {
                              x: _ctx.opCoords.chestR + 40,
                              y: _ctx.opCoords.chestY + 4,
                              "text-anchor": "middle",
                              class: "svg-measure-label red"
                            }, "가슴 " + _toDisplayString(_ctx.m.chest_width) + "cm", 9, _hoisted_144)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.m.waist_width)
                        ? (_openBlock(), _createElementBlock("g", _hoisted_145, [
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.waistL,
                              y1: _ctx.opCoords.waistY,
                              x2: _ctx.opCoords.waistR,
                              y2: _ctx.opCoords.waistY,
                              stroke: "#3498db",
                              "stroke-width": "0.8",
                              "stroke-dasharray": "4,2"
                            }, null, 8, _hoisted_146),
                            _createElementVNode("rect", {
                              x: _ctx.opCoords.waistR + 6,
                              y: _ctx.opCoords.waistY - 8,
                              width: "68",
                              height: "16",
                              rx: "3",
                              fill: "#fff",
                              stroke: "#c0d8f0",
                              "stroke-width": "0.5"
                            }, null, 8, _hoisted_147),
                            _createElementVNode("text", {
                              x: _ctx.opCoords.waistR + 40,
                              y: _ctx.opCoords.waistY + 4,
                              "text-anchor": "middle",
                              class: "svg-measure-label blue"
                            }, "허리 " + _toDisplayString(_ctx.m.waist_width) + "cm", 9, _hoisted_148)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.m.hip_width)
                        ? (_openBlock(), _createElementBlock("g", _hoisted_149, [
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.hipL,
                              y1: _ctx.opCoords.hipY,
                              x2: _ctx.opCoords.hipR,
                              y2: _ctx.opCoords.hipY,
                              stroke: "#27ae60",
                              "stroke-width": "0.8",
                              "stroke-dasharray": "4,2"
                            }, null, 8, _hoisted_150),
                            _createElementVNode("rect", {
                              x: _ctx.opCoords.hipR + 6,
                              y: _ctx.opCoords.hipY - 8,
                              width: "72",
                              height: "16",
                              rx: "3",
                              fill: "#fff",
                              stroke: "#b0d8b0",
                              "stroke-width": "0.5"
                            }, null, 8, _hoisted_151),
                            _createElementVNode("text", {
                              x: _ctx.opCoords.hipR + 42,
                              y: _ctx.opCoords.hipY + 4,
                              "text-anchor": "middle",
                              class: "svg-measure-label green"
                            }, "엉덩이 " + _toDisplayString(_ctx.m.hip_width) + "cm", 9, _hoisted_152)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.m.sleeve_length)
                        ? (_openBlock(), _createElementBlock("g", _hoisted_153, [
                            _createElementVNode("line", {
                              x1: _ctx.opCoords.shoulderR,
                              y1: _ctx.opCoords.topY,
                              x2: _ctx.opCoords.sleeveEndX,
                              y2: _ctx.opCoords.sleeveEndY,
                              stroke: "#3498db",
                              "stroke-width": "0.8",
                              "stroke-dasharray": "4,2"
                            }, null, 8, _hoisted_154),
                            _createElementVNode("rect", {
                              x: _ctx.opCoords.sleeveEndX - 4,
                              y: _ctx.opCoords.sleeveEndY + 4,
                              width: "68",
                              height: "16",
                              rx: "3",
                              fill: "#fff",
                              stroke: "#c0d8f0",
                              "stroke-width": "0.5"
                            }, null, 8, _hoisted_155),
                            _createElementVNode("text", {
                              x: _ctx.opCoords.sleeveEndX + 30,
                              y: _ctx.opCoords.sleeveEndY + 16,
                              "text-anchor": "middle",
                              class: "svg-measure-label blue"
                            }, "소매 " + _toDisplayString(_ctx.m.sleeve_length) + "cm", 9, _hoisted_156)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.svgCategory === 'SHOES')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_157, [
                        _hoisted_158,
                        _createElementVNode("path", {
                          d: _ctx.shoesSvgPath,
                          fill: "url(#shoeGrad)",
                          stroke: "#8a7560",
                          "stroke-width": "2",
                          "stroke-linejoin": "round"
                        }, null, 8, _hoisted_159),
                        (_ctx.m.foot_length)
                          ? (_openBlock(), _createElementBlock("g", _hoisted_160, [
                              _createElementVNode("line", {
                                x1: _ctx.shoeCoords.toeX,
                                y1: _ctx.shoeCoords.bottomY + 16,
                                x2: _ctx.shoeCoords.heelX,
                                y2: _ctx.shoeCoords.bottomY + 16,
                                stroke: "#888",
                                "stroke-width": "0.8",
                                "stroke-dasharray": "4,2"
                              }, null, 8, _hoisted_161),
                              _createElementVNode("line", {
                                x1: _ctx.shoeCoords.toeX,
                                y1: _ctx.shoeCoords.bottomY + 12,
                                x2: _ctx.shoeCoords.toeX,
                                y2: _ctx.shoeCoords.bottomY + 20,
                                stroke: "#888",
                                "stroke-width": "1"
                              }, null, 8, _hoisted_162),
                              _createElementVNode("line", {
                                x1: _ctx.shoeCoords.heelX,
                                y1: _ctx.shoeCoords.bottomY + 12,
                                x2: _ctx.shoeCoords.heelX,
                                y2: _ctx.shoeCoords.bottomY + 20,
                                stroke: "#888",
                                "stroke-width": "1"
                              }, null, 8, _hoisted_163),
                              _createElementVNode("rect", {
                                x: (_ctx.shoeCoords.toeX + _ctx.shoeCoords.heelX) / 2 - 34,
                                y: _ctx.shoeCoords.bottomY + 22,
                                width: "68",
                                height: "16",
                                rx: "3",
                                fill: "#fff",
                                stroke: "#ddd",
                                "stroke-width": "0.5"
                              }, null, 8, _hoisted_164),
                              _createElementVNode("text", {
                                x: (_ctx.shoeCoords.toeX + _ctx.shoeCoords.heelX) / 2,
                                y: _ctx.shoeCoords.bottomY + 34,
                                "text-anchor": "middle",
                                class: "svg-measure-label"
                              }, "발길이 " + _toDisplayString(_ctx.m.foot_length) + "mm", 9, _hoisted_165)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.m.ball_width)
                          ? (_openBlock(), _createElementBlock("g", _hoisted_166, [
                              _createElementVNode("line", {
                                x1: _ctx.shoeCoords.ballX,
                                y1: _ctx.shoeCoords.ballTopY,
                                x2: _ctx.shoeCoords.ballX,
                                y2: _ctx.shoeCoords.bottomY,
                                stroke: "#e74c3c",
                                "stroke-width": "0.8",
                                "stroke-dasharray": "4,2"
                              }, null, 8, _hoisted_167),
                              _createElementVNode("line", {
                                x1: _ctx.shoeCoords.ballX - 4,
                                y1: _ctx.shoeCoords.ballTopY,
                                x2: _ctx.shoeCoords.ballX + 4,
                                y2: _ctx.shoeCoords.ballTopY,
                                stroke: "#e74c3c",
                                "stroke-width": "1"
                              }, null, 8, _hoisted_168),
                              _createElementVNode("line", {
                                x1: _ctx.shoeCoords.ballX - 4,
                                y1: _ctx.shoeCoords.bottomY,
                                x2: _ctx.shoeCoords.ballX + 4,
                                y2: _ctx.shoeCoords.bottomY,
                                stroke: "#e74c3c",
                                "stroke-width": "1"
                              }, null, 8, _hoisted_169),
                              _createElementVNode("rect", {
                                x: _ctx.shoeCoords.ballX + 8,
                                y: (_ctx.shoeCoords.ballTopY + _ctx.shoeCoords.bottomY) / 2 - 8,
                                width: "68",
                                height: "16",
                                rx: "3",
                                fill: "#fff",
                                stroke: "#f0c0c0",
                                "stroke-width": "0.5"
                              }, null, 8, _hoisted_170),
                              _createElementVNode("text", {
                                x: _ctx.shoeCoords.ballX + 42,
                                y: (_ctx.shoeCoords.ballTopY + _ctx.shoeCoords.bottomY) / 2 + 4,
                                "text-anchor": "middle",
                                class: "svg-measure-label red"
                              }, "발볼 " + _toDisplayString(_ctx.m.ball_width) + "mm", 9, _hoisted_171)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
            (!_ctx.hasMeasurements)
              ? (_openBlock(), _createElementBlock("div", _hoisted_172, "치수를 입력하면 다이어그램에 반영됩니다"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}